import { render, staticRenderFns } from "./ComputerList.vue?vue&type=template&id=38426d5d&"
import script from "./ComputerList.vue?vue&type=script&lang=js&"
export * from "./ComputerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports